import React, {Component} from 'react';
import {Form} from "antd";
import BaseComponent, {attrParser} from "../../../../base/BaseComponent";

class TagListInput extends BaseComponent {

    static defaultProps = {
        url : "/cm-sites-pms/media/getMediaByDept?deptId=${window.currentUser.deptIds.0}",
        method: "get",
        itemValue:[],
        width: 642
    };

    constructor(props) {
        super(props);
        this.state={
            allTags:[],
            checkedTagIds: props.itemValue.map(item=>item.id),
        }
    }

    componentDidMount() {
        this.getCurrentDeptMediaList();
    }

    // 获取当前部门下媒体列表
    getCurrentDeptMediaList = () => {
        this.request({
            url: attrParser(this.props.url, window),
            method: this.props.method,
            callBack: (res) => {
                if (res) {
                    // 这里只需要保留网站和微信媒体
                    let allTags = res.filter(item=>item.mediaTypeCode==="material" || item.mediaTypeCode==="webNews");
                    this.setState({allTags})
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    onchange = (tagId) =>{
        let checkedTags = this.state.checkedTagIds;
        let index = checkedTags.indexOf(tagId);
        if(index> -1){
            checkedTags.splice(index,1);
        }else {
            checkedTags.push(tagId);
        }
        if(this.state.allTags && this.props.callBack){
            this.props.callBack(this.state.allTags.filter(item=>checkedTags.find(id=>id === item.id)));
        }
        this.setState({checkedTagIds: checkedTags})
    };

    render() {
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <div style={{width:this.props.width}}>
                {
                    this.state.allTags.map((item)=>{
                        return <MyTag key={item.id} tagName={item.name} checked={this.state.checkedTagIds.includes(item.id)} onClick={()=>this.onchange(item.id)}/>
                    })
                }
                </div>
            </Form.Item>
        );
    }
}

class MyTag extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <span style={{cursor:"pointer", background: "rgba(0, 80, 179, 0.04)",padding: "0 10px", display:"inline-block", marginRight: 10, marginBottom:10, border: "1px solid",borderRadius:2, color: this.props.checked ? "#0050B3" : undefined, borderColor: this.props.checked ? "#0050B3" : "#e8e8e8"}}
                  onClick={this.props.onClick}>{this.props.tagName}
            </span>
        );
    }
}

export default TagListInput;
